<script>
import AppNavigatorLink from './_AppNavigatorLink'
import AppNavigatorMixin from '@/mixins/app_navigator'

export default {
  components: {
    AppNavigatorLink
  },
  mixins: [AppNavigatorMixin],
  props: {
    icon: { default: 'image', type: String }, // Icon for section
    collapsedLabel: { default: '', type: String }, // Label for section when collapsed
    iconAdjust: { default: 0, type: Number }, // Offsets # of px for the icon for odd shapes
    collapsed: { default: false, type: Boolean } // Hides Labels
  },
  computed: {
    hasChildren() {
      return this.dataObj.children.length > 0
    }
  },
  methods: {
    onClick() {
      if (
        typeof this.dataObj.path == 'object' &&
        (this.$route.name != this.dataObj.path.name ||
          JSON.stringify(this.$route.params) !=
            JSON.stringify(this.dataObj.path.params || {}))
      ) {
        this.$router.push(this.dataObj.path)
      }
    }
  }
}
</script>

<template>
  <div class="AppNavigatorSection" :class="selClass">
    <div v-if="collapsed" class="collapsedTitle" @click="onClick">
      {{ dataObj.collapsedLabel }}
    </div>
    <div
      v-if="!collapsed"
      class="icon"
      :style="'padding-left: ' + dataObj.iconAdjust + 'px'"
      @click="onClick"
    >
      <font-awesome-icon :icon="dataObj.icon" />
    </div>
    <div v-if="!collapsed" class="indicator" :class="selClass" @click="onClick">
      <font-awesome-icon icon="caret-right" />
    </div>
    <div v-if="!collapsed" class="label" @click="onClick">
      {{ dataObj.label }}
    </div>
    <div v-if="!collapsed && hasChildren" class="submenu" :class="selClass">
      <AppNavigatorLink
        v-for="child in dataObj.children"
        :key="child.label"
        :data="child"
        :collapsed="collapsed"
      />
    </div>
  </div>
</template>

<style>
.AppNavigatorSection {
  min-height: 50px;
  width: 100%;
  color: #fff;
  line-height: 50px;
}
#AppNavigator.collapsed .AppNavigatorSection {
  padding-top: 10px;
  padding-bottom: 10px;
}
.AppNavigatorSection .collapsedTitle {
  font-weight: bold;
  text-align: center;
  transform: rotate(-90deg);
  -webkit-transform: rotate(-90deg);
  -moz-transform: rotate(-90deg);
  -o-transform: rotate(-90deg);
  -ms-transform: rotate(-90deg);
  height: 110px;
  width: 150px;
  line-height: 20px;
}
.AppNavigatorSection:hover,
.AppNavigatorSection.selected {
  background-color: #194173;
  cursor: pointer;
}
.AppNavigatorSection.selected {
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
}
.AppNavigatorSection > .submenu {
  display: none;
  padding-top: 10px;
  padding-bottom: 10px;
}
.AppNavigatorSection > .submenu.selected {
  display: block;
  width: 100%;
  background-color: #194173;
  border-top: 1px solid #000;
}
.AppNavigatorSection .icon {
  float: left;
  width: 32px;
  height: 32px;
  font-size: 32px;
  margin-left: 10px;
  margin-right: 20px;
}
.AppNavigatorSection .label {
  font-size: 14pt;
  letter-spacing: 1.5px;
}
.AppNavigatorSection .indicator {
  display: none;
}
.AppNavigatorSection .indicator.selected {
  float: right;
  margin-right: 20px;
  font-weight: bold;
  font-size: 14pt;
  display: block;
}
</style>
